import unauthenticated_footer from './unauthenticated-footer.json';

export default {
  footer: {
    ...unauthenticated_footer,
  },
};
